// Copyright 2024 - MinIO, Inc. All rights reserved.

import { createAsyncThunk } from "@reduxjs/toolkit";
import { ErrorResponseHandler } from "../common/types";
import { setErrorSnackBarMessage } from "../../systemSlice";
import { oprRpc } from "../../../api";
import { AsyncResourceRequest } from "common/common.types";

export const getTenantAsync = createAsyncThunk(
  "tenantDetails/getTenantAsync",
  async (
    req: AsyncResourceRequest,
    { getState, rejectWithValue, dispatch },
  ) => {
    return oprRpc.api
      .getTenant(req.siteId, req.namespace, req.resourceId)
      .then((res) => {
        return res.data;
      })
      .catch((err) => {
        console.log(err);
        dispatch(setErrorSnackBarMessage(err.error));
        return rejectWithValue(err);
      });
  },
);

export const getTenant = createAsyncThunk(
  "tenantDetails/getTenant",
  async (
    req: AsyncResourceRequest,
    { getState, rejectWithValue, dispatch },
  ) => {
    return oprRpc.api
      .getTenant(req.siteId, req.namespace, req.resourceId)
      .then((res) => {
        return res.data;
      })
      .catch((err: ErrorResponseHandler) => {
        dispatch(setErrorSnackBarMessage(err));
        return rejectWithValue(err);
      });
  },
);
